import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams, useSearchParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { WhyUs } from "@/components/WhyUs";
import { Pricing } from "@/components/Pricing";
import { Process } from "@/components/Process";
import { Faq } from "@/components/Faq";
import { Gdpr } from "@/components/Gdpr";
import { ContactForm } from "@/components/ContactForm";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { ChatWidget } from "@/components/ChatWidget";
import { CountryHero } from "@/components/CountryHero";
import { VideoSection } from "@/components/VideoSection";
import { markets } from "@/i18n/translations";

const Home = () => (
  <>
    <Header />
    <main>
      <Hero />
      <VideoSection />
      <Services />
      <WhyUs />
      <Pricing />
      <Process />
      <Faq />
      <ContactForm />
      <Gdpr />
    </main>
    <Footer />
    <WhatsAppButton />
    <ChatWidget />
  </>
);

const SUPPORTED_LANGS = ["ro", "en", "bg", "sr", "hu"];

const LocalizedPage = ({ lang }) => (
  <LanguageProvider forcedLang={lang}>
    <Home />
  </LanguageProvider>
);

const RootRoute = () => {
  const [searchParams] = useSearchParams();
  const urlLang = searchParams.get("lang");
  if (urlLang && SUPPORTED_LANGS.includes(urlLang) && urlLang !== "ro") {
    return <Navigate to={`/${urlLang}`} replace />;
  }
  return <LocalizedPage lang="ro" />;
};

const LangRoute = () => {
  const { lang } = useParams();
  if (!lang || !SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to="/" replace />;
  }
  return <LocalizedPage lang={lang} />;
};

const CountryPage = ({ marketKey }) => {
  const market = markets[marketKey];
  return (
    <LanguageProvider forcedLang={market.lang} docTitle={market.docTitle}>
      <>
        <Header />
        <main>
          <CountryHero market={market} />
          <VideoSection />
          <Services />
          <WhyUs />
          <Pricing />
          <Process />
          <Faq />
          <ContactForm />
          <Gdpr />
        </main>
        <Footer />
        <WhatsAppButton />
        <ChatWidget />
      </>
    </LanguageProvider>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRoute />} />
          <Route path="/bulgaria" element={<CountryPage marketKey="bulgaria" />} />
          <Route path="/serbia" element={<CountryPage marketKey="serbia" />} />
          <Route path="/hungary" element={<CountryPage marketKey="hungary" />} />
          <Route path="/romania" element={<CountryPage marketKey="romania" />} />
          <Route path="/:lang" element={<LangRoute />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
